import { IOnInit } from "angular";
import { MachineConfigurationViewSycuan } from "../../../../models/machineConfiguration";
import { IFieldArray } from "AngularFormly";
import {
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../../../records/forms/formView";
import { StateService } from "@uirouter/angularjs";
import { RecordFileTemplateOptions } from "../../../../../../records/forms/formly/types";
import fieldHelpers from "../../../../../../ui-formly/fieldHelpers";
import { cloneDeep } from "lodash";

interface MachinesWarehouseFormModel {
  MachineChanges?: MachineWarehouseMachine[];
  Date?: Date;
  Files?: File[];
}

interface MachineWarehouseMachine {
  MachineId: number;
}
export class MachinesMoveViewComponentController implements IOnInit {
  static $inject = [FormViewServiceName, "$state"];

  formFields!: IFieldArray;
  machineInfo!: { machineConfigurations: MachineConfigurationViewSycuan[] };

  /* start bindings */
  readonly machineConfigurations!: MachineConfigurationViewSycuan[];
  /* end binding */

  model!: MachinesWarehouseFormModel;

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService
  ) {}

  private initializeFormFields(machineInfo: {
    machineConfigurations: MachineConfigurationViewSycuan[];
  }) {
    const fileTemplateOptions: RecordFileTemplateOptions = {
      allowMultiple: true,
      label: "Files",
    };

    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleDateField({
            key: "Date",
            name: "Date",
            label: "Change Date",
            required: true,
          }),
          fieldHelpers.simpleStringField({
            key: "WarehouseLocation",
            name: "WarehouseLocation",
            label: "Location",
            required: true,
          }),
        ],
        4
      ),
      fieldHelpers.headerField({
        headerText: "Machines",
        key: "MachinesHeader",
      }),
      {
        key: "machineConfigurations",
        model: machineInfo,
        template: require("!html-loader!../sharedTemplates/machineList.html")
          .default,
      },
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: fileTemplateOptions,
      },
      fieldHelpers.headerField({ headerText: "Notes", key: "NotesHeader" }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
    ];
  }

  $onInit(): void {
    this.model = {
      Date: undefined,
      Files: [],
      MachineChanges: (this.machineConfigurations ?? []).map((mc) => {
        return { MachineId: mc.MachineId };
      }),
    };
    this.machineInfo = {
      machineConfigurations: cloneDeep(this.machineConfigurations),
    };
    this.initializeFormFields(this.machineInfo);
  }

  async submit(formViewController: FormViewController): Promise<void> {
    await this.formViewService.submitForm({
      url: `/api/machines/warehouse`,
      formObject: this.model,
      formViewController,
      method: "post",
    });

    await this.$state.go("^.grid", undefined, { reload: true });
  }

  async cancel(): Promise<void> {
    await this.$state.go("^.grid");
  }
}
